export class BasicProperties {
    constructor() {
    }
}

